import { typo } from '@design-system/styles'
import { css } from '@emotion/react'

const listBox = css`
  display: flex;
  flex-direction: column;
  flex: 1 1;
`

const S = {
  container: css`
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
  `,
  nav: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
  main: css`
    display: flex;
    gap: 12px;
    height: 100%;
  `,
  leftListBox: css`
    ${listBox};
    .student-list {
      border: 1px solid var(--Colors-Gray-400);
      border-radius: var(--Radius-100);
    }
  `,
  rightListBox: css`
    ${listBox};
    border: 1px solid var(--Colors-Gray-400);
    border-radius: var(--Radius-100);
  `,
  rightHeader: css`
    display: flex;
    gap: 8px;
    flex-shrink: 0;
    align-items: center;
    height: 48px;
    padding: 0 24px;
    border-bottom: 1px solid var(--Colors-Gray-400);

    > strong {
      flex-shrink: 0;
    }

    > span {
      ${typo.body02};
      color: var(--Colors-Ash-600);
    }
  `,
  list: css`
    display: flex;
    flex-direction: column;
    flex: auto;
    height: 100%;
    overflow: hidden;
  `,
  searchWrap: css`
    margin-bottom: 8px;
  `,
}

export default S
